import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "ref-agent-token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: API, timeout: 30000 });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const errorText = (err, fallback = "Something went wrong. Please try again.") => {
  if (err?.code === "ECONNABORTED") return "This is taking longer than usual. Please try again.";
  if (!err?.response) return "We couldn't reach Landin. Check your connection and try again.";
  const d = err.response.data?.detail;
  return typeof d === "string" ? d : fallback;
};
